import React from "react";
import PropTypes from "prop-types";
import BaseExitButton from "../BaseExitButton";
import useModalActions from "../../hooks/useModalActions";
import { MODAL_TYPES } from "../../utils/emitter";
import i18n from "i18next";
export default function ExitGameButton({
  title = i18n.t("exit_game"),
  onClick,
}) {
  ExitGameButton.propTypes = {
    title: PropTypes.string,
    onClick: PropTypes.func,
  };
  const { openModal } = useModalActions();
  const click = () => {
    openModal(MODAL_TYPES.EXIT);
    onClick && onClick();
  };
  return <BaseExitButton label={title} onClick={click} />;
}
